import { create } from 'zustand';
import {
  Banner,
  Activity,
  DappModuleDataType,
  NoticeItem,
  TokenDetail,
} from '@/types/home';
import { Chain } from '@web3/base-utils';

/**
 * const [banners, setBanners] = useState<Banner[]>([]);
 *   const [activities, setActivities] = useState<Activity[]>([]);
 *   const [dapps, setDapps] = useState<DappModuleDataType[]>([]);
 *
 *   const [notices, setNotices] = useState<NoticeItem[]>([]);
 *   const [tokens, setTokens] = useState<TokenRankItem[]>([]);
 */

interface StoreType {
  banners: Banner[];
  setBanners: (banners: Banner[]) => void;
  bannerIsReady: boolean;
  activities: Activity[];
  activitiesIsReady: boolean;
  setActivities: (activities: Activity[]) => void;
  dapps: DappModuleDataType[];
  setDapps: (dapps: DappModuleDataType[]) => void;
  notices: NoticeItem[];
  setNotices: (notices: NoticeItem[]) => void;
  tokens: TokenDetail[];
  setTokens: (tokens: TokenDetail[]) => void;
  chains: Chain[];
  setChains: (chains: Chain[]) => void;
}

export const useHomeStore = create<StoreType>()((set) => ({
  banners: [],
  bannerIsReady: false,
  setBanners: (banners) => set({ banners, bannerIsReady: true }),
  activities: [],
  activitiesIsReady: false,
  setActivities: (activities) => set({ activities, activitiesIsReady: true }),
  dapps: [],
  setDapps: (dapps) => set({ dapps }),
  notices: [],
  setNotices: (notices) => set({ notices }),
  tokens: [],
  setTokens: (tokens) => set({ tokens }),
  chains: [],
  setChains: (chains) => set({ chains }),
}));
